namespace $.$$ {
	
	$mol_style_define( $shm_hitalama_map_widget_float_code_html_bench_result, {

		Frame: {
			width: '100%',
			minHeight: '20rem',
			padding: 0,
			border: {
				radius: 0,
			},
			colorScheme: 'auto',
		},

	} )
	
}
